if (!customElements.get('calm-pair-edit')) {
  customElements.define('calm-pair-edit', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('form');
      this.size = this.querySelector('[data-pair-size]');
      this.first = this.querySelector('[data-pair-first]');
      this.second = this.querySelector('[data-pair-second]');
      if (!this.size.options.length) return;
      this.querySelector('.calm-pair__shared').hidden = false;
      this.querySelector('.calm-pair__individual').hidden = true;
      this.querySelector('[data-pair-price-row]').hidden = false;
      this.sync = () => {
        const option = this.size.selectedOptions[0];
        this.first.value = option.value;
        this.second.value = option.dataset.second;
        this.querySelector('[data-pair-total]').textContent = option.dataset.price;
      };
      this.size.addEventListener('change', (event) => {
        const previous = this.first.value;
        this.sync();
        if (event.isTrusted && previous !== this.first.value) {
          window.CalmCRO?.emit('size_selected', { source: 'pair', size: window.CalmCRO?.sizeForVariant(this.first.value) });
        }
      });
      this.sync();
      this.form.addEventListener('submit', async (event) => {
        const drawer = document.querySelector('cart-drawer');
        if (!drawer?.renderContents) return;
        event.preventDefault();
        const button = this.querySelector('[data-pair-submit]');
        if (button.disabled) return;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        const error = this.querySelector('[data-pair-error]');
        error.textContent = '';
        drawer.setActiveElement(button);
        let added = false;
        let committed = false;
        let stage = 'transport';
        const croRequest = {};
        const size = window.CalmCRO?.sizeForVariant(this.first.value);
        window.CalmCRO?.emit('pair_submitted', { size });
        try {
          const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: this.first.value, quantity: 1 }, { id: this.second.value, quantity: 1 }], sections: drawer.getSectionsToRender().map((section) => section.id), sections_url: window.location.pathname })
          });
          added = response.ok;
          const state = await response.json();
          stage = 'api';
          if (!response.ok || state.status) throw new Error(state.description || this.form.dataset.error);
          committed = true;
          stage = 'render';
          window.CalmCRO?.emit('pair_add_success', { size });
          drawer.classList.remove('is-empty');
          if (state.sections?.['cart-drawer'] && state.sections?.['cart-icon-bubble']) drawer.renderContents(state);
          else {
            window.CalmCRO?.once(croRequest, 'error', 'cart_error', { source: 'pair', stage, committed });
            window.location.assign(window.Shopify.routes.root + 'cart');
          }
        } catch (failure) {
          window.CalmCRO?.once(croRequest, 'error', 'cart_error', { source: 'pair', stage, committed });
          if (added) window.location.assign(window.Shopify.routes.root + 'cart');
          else error.textContent = failure.message || this.form.dataset.error;
        } finally {
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      });
    }
  });
}
